import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

export interface RouterLinkInterface {
  name: string;
  path: string;
  url?: string;
  targetBlank?: boolean;
  children?: Array<RouterLinkInterface>;
}

interface Props {
  item: RouterLinkInterface
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomRouterLink',
  props: {
    item: {}
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (props.item?.path.startsWith('http'))
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: props.item?.path
      }, _toDisplayString(props.item.name), 9 /* TEXT, PROPS */, _hoisted_1))
    : (_openBlock(), _createBlock(_component_RouterLink, {
        key: 1,
        to: props.item.children ? '' : props.item.path
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["to"]))
}
}

})